exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".backup-required {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-flow: column nowrap;\n          flex-flow: column nowrap;\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n  -ms-flex-line-pack: start;\n      align-content: flex-start;\n  padding: 36px;\n}\n.backup-required > * {\n  -webkit-box-flex: 0;\n      -ms-flex: 0 0 auto;\n          flex: 0 0 auto;\n}\n.backup-required h4 {\n  color: #56585a;\n}\n.backup-required p {\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  color: #56585a;\n  margin: 0;\n  padding: 0;\n  font-size: 13px;\n  margin-bottom: 12px;\n  margin-left: 12px;\n}\n.backup-required button {\n  margin-left: 12px;\n}\n.backup-required button:hover {\n  background-color: #32b4e5 !important;\n  color: #ffffff;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/backup/backup-project.component.less
// module id = 1485
// module chunks = 0